import { useState } from "react";
import { Phone, MapPin, Mail } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { PageHero } from "@/components/marketing/PageHero";
import { CtaRedeApoio } from "@/components/marketing/CtaRedeApoio";
import contatoImg from "@/assets/images/contato-1.png";

export default function Contato() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const validate = () => {
    const err = {};
    if (!form.name.trim()) err.name = "Informe seu nome";
    if (!/^\S+@\S+\.\S+$/.test(form.email)) err.email = "E-mail inválido";
    if (!form.phone.trim()) err.phone = "Informe seu telefone";
    if (!form.message.trim()) err.message = "Escreva sua mensagem";
    setErrors(err);
    return Object.keys(err).length === 0;
  };

  const submit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);
    try {
      await api.post("/contact", form);
      toast.success("Mensagem enviada com sucesso!");
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Erro ao enviar");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="page-contato">
      <PageHero title="Contato" testId="contato-hero" />
      <section className="mc-container py-16 grid lg:grid-cols-2 gap-12 items-start">
        <form onSubmit={submit} className="space-y-5" data-testid="contact-form" noValidate>
          <Field label="Nome Completo" error={errors.name}>
            <input className="mc-input" data-testid="contact-name" placeholder="Digite seu nome completo" value={form.name} onChange={set("name")} />
          </Field>
          <Field label="E-mail" error={errors.email}>
            <input className="mc-input" data-testid="contact-email" placeholder="Digite seu e-mail" value={form.email} onChange={set("email")} />
          </Field>
          <Field label="Seu telefone" error={errors.phone}>
            <input className="mc-input" data-testid="contact-phone" placeholder="(43) 99123 - 4567" value={form.phone} onChange={set("phone")} />
          </Field>
          <Field label="Menssagem" error={errors.message}>
            <textarea className="mc-input" rows={4} data-testid="contact-message" placeholder="Escreva sua menssagem...." value={form.message} onChange={set("message")} />
          </Field>
          <button className="btn-primary" data-testid="contact-submit" disabled={loading}>{loading ? "Enviando..." : "Enviar"}</button>
        </form>

        <div>
          <img src={contatoImg} alt="Contato" loading="lazy"
            className="w-full max-w-sm mx-auto aspect-[4/3] object-cover mc-hex" />
          <div className="mc-card -mt-6 relative p-7">
            <h3 className="text-2xl font-bold text-[#1e1b2e]">Entre em contato</h3>
            <ul className="mt-5 space-y-4 text-[15px]">
              <li className="flex items-center gap-3"><Phone size={18} className="text-violet-600" /> (105) 115-2920</li>
              <li className="flex items-center gap-3"><MapPin size={18} className="text-violet-600" /> Londrina, PR</li>
              <li className="flex items-center gap-3"><Mail size={18} className="text-violet-600" /> meajuda@moracomigo.com</li>
            </ul>
          </div>
        </div>
      </section>
      <CtaRedeApoio />
    </div>
  );
}

function Field({ label, error, children }) {
  return (
    <div>
      <label className="block text-sm font-semibold text-[#1e1b2e] mb-2">{label}</label>
      {children}
      {error && <p className="text-destructive text-xs mt-1" data-testid="field-error">{error}</p>}
    </div>
  );
}
